import { createSelector } from '@reduxjs/toolkit'

import {
  displayTotalWithTaxesSelector,
  isCurrentRegionUsingFlatTaxSelector
} from '@/selectors'
import { isCartPath, isGuestCheckoutPath } from '@/utils/path'
import { translate } from '@/utils/translations'

export const displayTaxesSelector = createSelector(
  [
    state => state.taxes.total,
    displayTotalWithTaxesSelector,
    isCurrentRegionUsingFlatTaxSelector
  ],
  (total, displayTotalWithTaxes, isUsingFlatTax) => {
    if ((isCartPath || isGuestCheckoutPath) && !isUsingFlatTax) {
      return translate('carts.calculated_in_checkout')
    } else if (displayTotalWithTaxes) {
      return total
    } else {
      return translate('carts.checkout_tax_info')
    }
  }
)

export const canShowVatTaxMessageSelector = createSelector(
  [
    state => state.taxes.vatTaxMessage,
    state => state.taxes.hasNZTax
  ],
  (vatTaxMessage, hasNZTax) => vatTaxMessage && !hasNZTax
)
